import { ProductCardData } from '@/types/Product';
import { productUrlIOSDeepLink } from './iosDeepLinks';

/**
 * Generates a product URL for Ella based on the product data and environment
 * @param product - The product data
 * @param isIOSWebView - Whether the current environment is an iOS WebView
 * @returns The generated URL string
 */
export const generateEllaProductUrl = (
  product: Pick<ProductCardData, 'cj_link' | 'sku' | 'slug'>,
  isIOSWebView: boolean
): string => {
  if (product.cj_link) {
    return product.cj_link;
  }

  if (isIOSWebView) {
    return productUrlIOSDeepLink(product.sku);
  }

  return `/products/${product.slug}`;
};
